<mat-progress-bar *ngIf="isVisible$ | async" class="progress-bar" mode="indeterminate" color="warn"></mat-progress-bar>
